export default __webpack_public_path__ + "static/media/img_ground-m.b26f9455.jpg";